import React from 'react';

import { ReactComponent as DownloadIcon } from '../../../assets/svg/download.svg';
import { ReactComponent as MoreIcon } from '../../../assets/svg/moreoptions2.svg';
import { ReactComponent as SearchIcon } from '../../../assets/svg/search.svg';
import { ReactComponent as CloseIcon } from '../../../assets/svg/cross.svg';
import _ from 'lodash';

class ShootPageHeader extends React.Component {
	constructor() {
		super();
		this.state = {
			isSearchExpanded: false,
			showMemoryCardDropdown: false,
		};
		this.searchref = React.createRef();
		this.dropdownref = React.createRef();
		this.wrapper = React.createRef();
	}

	componentDidMount = async () => {
		document.addEventListener('mousedown', this.handleClickOutside);
	};

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	handleClickOutside = (event) => {
		if (
			this.props.searchQuery === '' &&
			this.searchref.current &&
			!this.searchref.current.contains(event.target)
		) {
			this.setState({
				isSearchExpanded: false,
			});
		}
		if (
			this.dropdownref.current &&
			!this.dropdownref.current.contains(event.target) &&
			this.wrapper.current &&
			!this.wrapper.current.contains(event.target)
		) {
			this.setState({
				showMemoryCardDropdown: false,
			});
		}
	};

	toggleMemoryCardDropDown = () => {
		this.setState({
			showMemoryCardDropdown: !this.state.showMemoryCardDropdown,
		});
	};

	render() {
		return (
			<div className="shoot-page-header-container">
				<div className="shoot-page-header-left">
					<span className="header-title">{this.props.title}</span>
				</div>
				<div className="shoot-page-header-right">
					{_.has(this.props, 'onSearch') ? (
						<a
							className={
								this.state.isSearchExpanded === true
									? 'huemn-search-container expand'
									: 'huemn-search-container'
							}
							onClick={() => {
								document.getElementById('idOfNavSearch').focus();
								this.setState({ isSearchExpanded: true });
							}}
							ref={this.searchref}
						>
							<SearchIcon />
							<input
								id="idOfNavSearch"
								type="text"
								value={this.props.searchQuery}
								onChange={(e) => this.props.onSearch(e.target.value)}
								placeholder={'Search'}
							/>
							<span
								className="search-close-icn"
								onClick={(e) => {
									if (this.props.searchQuery !== '') {
										this.props.onSearch('');
									}
								}}
							>
								<CloseIcon />
							</span>
						</a>
					) : null}
					<span className="sp-download-btn" onClick={this.props.onClickDownload}>
						<DownloadIcon />
					</span>
					<span
						className="sp-dropdown-btn"
						onClick={(e) => this.toggleMemoryCardDropDown(e)}
						ref={this.dropdownref}
					>
						<MoreIcon />
						{this.state.showMemoryCardDropdown ? (
							<div className="sp-dropdown-container" ref={this.wrapper}>
								{_.map(this.props.moreList, (item, index) => {
									return (
										<a onClick={(e) => this.props.moreItemSelected(item)}>
											{item}
										</a>
									);
								})}
							</div>
						) : (
							''
						)}
					</span>
				</div>
			</div>
		);
	}
}

export default ShootPageHeader;
